import React from 'react';
import Details from './box/Details'
import RealTime from './box/RealTime';
import Share from './box/share';
import Liked from './box/liked';


const styles = {
    divStyle:{
        flex: 1,
        marginLeft: "25px",
        marginRight: "auto",
        marginTop: "75px",
        height: "300px"
    },
    flexStyle:{
        display: "flex",
        marginLeft: "70px"
    }
  
}


const ShowDetails = (props)=>{
    const {divStyle, flexStyle } = styles;
    return(
        <div style={divStyle}>
             <div style={flexStyle}>
                 <Share  currentName={props.currentName}/> 
                 <Liked currentName={props.currentName}/>
             </div>
           <hr/>
             <Details currentName={props.currentName}/>
             <RealTime favourites={props.favourites} />
        </div>
    )
};



export default ShowDetails;


// WEBPACK FOOTER //
// ./src/components/mainpage/ShowDetails.js